import UpdateAddress from 'features/myVaro/screens/ExternalAccounts/UpdateAddress';
import React from 'react';

export default function UpdateAddressPage() {
  return <UpdateAddress />;
}
